import React from "react";
import { CalendarDays, Users, Map, Newspaper, Bike } from "lucide-react";

interface SummaryCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
  subtitle: string;
}

export const AdminDashboard = () => {
  return (
    <div className="container py-4">
      {/* Résumé rapide */}
      <div className="row g-4 mb-4">
        <SummaryCard icon={<Users />} title="Membres" value="128" subtitle="5 nouveaux ce mois" />
        <SummaryCard icon={<Newspaper />} title="Actualités" value="23" subtitle="2 en brouillon" />
        <SummaryCard icon={<Map />} title="Parcours" value="47" subtitle="+1 cette semaine" />
        <SummaryCard icon={<CalendarDays />} title="Événements" value="3 à venir" subtitle="Prochaine sortie : 20/04" />
        <SummaryCard icon={<Bike />} title="Équipement" value="8 dispo" subtitle="2 demandes en attente" />
        <SummaryCard icon={<Users />} title="Bureau" value="6 membres" subtitle="À jour" />
      </div>

      {/* Prochains événements */}
      <div className="card mb-4">
        <div className="card-header">📆 Prochains événements</div>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">🚴 Sortie Montagne - 20 avril 2025</li>
          <li className="list-group-item">🏛 Réunion bureau - 25 avril 2025</li>
          <li className="list-group-item">🚴 Sortie Route - 27 avril 2025</li>
        </ul>
      </div>

      {/* Actions rapides */}
      <div className="card mb-4">
        <div className="card-header">⚡ Actions rapides</div>
        <div className="card-body d-flex flex-wrap gap-2">
          <button className="btn btn-outline-primary">Valider des membres</button>
          <button className="btn btn-outline-primary">Publier une actu</button>
          <button className="btn btn-outline-primary">Ajouter un parcours</button>
          <button className="btn btn-outline-primary">Créer un événement</button>
          <button className="btn btn-outline-primary">Gérer équipement</button>
        </div>
      </div>

      {/* Notifications */}
      <div className="card">
        <div className="card-header">🔔 Notifications</div>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">1 membre en attente de validation</li>
          <li className="list-group-item">Parcours "Forêt Est" signalé comme dangereux</li>
          <li className="list-group-item">Casque prêté non retourné</li>
        </ul>
      </div>
    </div>
  );
}

function SummaryCard({ icon, title, value, subtitle }: SummaryCardProps): JSX.Element {
  return (
    <div className="col-md-4">
      <div className="card h-100 d-flex flex-row align-items-center p-3 gap-3">
        <div className="text-primary fs-3">{icon}</div>
        <div>
          <div className="fs-4 fw-bold">{value}</div>
          <div className="text-muted">{title}</div>
          <div className="text-secondary small fst-italic">{subtitle}</div>
        </div>
      </div>
    </div>
  );
}